// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__h7gZw","header":"MergedInvoice_header__3GuZn"};